// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__LLRjx","loader":"loader_loader__RVUgF","l1":"loader_l1__vH9T5"};